if not App.angularApp?
    return

App.angularApp.directive 'mfGuardMin', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>
            element.on('blur', (e) =>
                if Number(element.val()) < Number(attrs.mfGuardMin)
                    element.val(null)
                    ngModel.$setViewValue(null)
            )
    }
